import { Box, Container, Typography } from '@mui/material';
import { ResourceManagement } from 'components/templates/ResourceManagement';

export const ResourcesView = () => {
  return (
    <Container>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Resources
        </Typography>
      </Box>
      <ResourceManagement />
    </Container>
  );
};
